import {
  AfterViewInit, Component, ComponentFactoryResolver, Input, OnInit, Type, ViewChild,
  ViewContainerRef,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import {take, takeUntil} from 'rxjs/operators';
import {BehaviorSubject, Subject} from 'rxjs';
import {IMenuItem} from '@shared/interfaces/menu-item.interface';
import {TaskMenuItem} from '../../models/task-manager.model';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {select, Store} from '@ngrx/store';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {getTaskCreationMenuList, getTaskManagementMenuList} from '../../store/task-manager.selector';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DateUtility} from '@shared/utility/date-utility';

@Component({
    standalone: false,
    selector: 'particle-task-management-detail',
  templateUrl: './task-management-detail.component.html',
  styleUrls: ['./task-management-detail.component.scss']
})
export class TaskManagementDetailComponent implements OnInit, IDialogView, AfterViewInit {
  @ViewChild('dynamicComponent', {read: ViewContainerRef}) viewContainerRef;
  menuItems$ = new Subject<void>();
  selectedMenu$ = new Subject<void>();
  data: DialogModel;
  currentlyOpenedEditor: string;
  taskMenuItems: TaskMenuItem[] = [];
  selectedMenu: any;
  taskDialogMenuItems: IMenuItem[];
  indirectMenuItemClickedEvent: Subject<IMenuItem> = new Subject<IMenuItem>();
  componentView: any;

  constructor(private taskManagerStore: Store<TaskManagerState>,
              private componentFactoryResolver: ComponentFactoryResolver,
              private queryStore: Store<IQueryState>,
              private snackBarService: SnackBarService
  ) {
  }

  ngOnInit() {
    console.log('task data input', this.data.input);
  }

  ngAfterViewInit(): void {
    if (!('showVerticalMenu' in this.data.input)) {
      this.data.input.showVerticalMenu = true;
    }
    this.queryStore.pipe(select(getQueryResponse, 'taskDialogMenu')).pipe(take(2)).subscribe(filter => {
      console.log('taskDialogMenu:', filter);
      if (filter && filter.taskDialogMenu) {
        this.taskDialogMenuItems = filter.taskDialogMenu;
        this.menuItems$.next(filter.taskDialogMenu);
        this.selectedMenu = filter.taskDialogMenu.find(menu => menu.id === 'TaskDetail');
        if (!this.selectedMenu) {
          this.selectedMenu = filter.taskDialogMenu[0];
        }
        if (this.data.input.selectedMenuDetail) {
          this.selectedMenu = filter.taskDialogMenu.find(menu => menu.id === this.data.input.selectedMenuDetail.id);
          this.menuClicked(this.selectedMenu);
        } else {
          this.menuClicked(this.selectedMenu);
        }
        this.selectedMenu$.next(this.selectedMenu.id);

      }
    });
    QueryProvider.invokeQuery(this.queryStore, 'taskDialogMenu', {'[TEMPLATE]': this.data.input.template});

  }

  menuClicked($event) {
    if (!$event.editor || $event.editor === this.currentlyOpenedEditor) {
      return;
    }
    this.currentlyOpenedEditor = $event.editor;

    if (this.data.input.detailFormValueChanged && this.data.input.detailChangedSubject) {
      this.data.input.detailFormValueChanged = false;

      if (DateUtility.isValidDate(this.data.input.card.taskStartDate) && DateUtility.isValidDate(this.data.input.card.dueDate) &&
        this.data.input.card.taskStartDate.getTime() > this.data.input.card.dueDate.getTime()
      ){
        this.snackBarService.showError('Please make sure the due date is not set before the start date.');
      }
      else {
            this.data.input.detailChangedSubject.next(this.data.input);
     }
    }

    const resolvedComponent = <Type<any>>RootDynamicComponentHelper.getComponent($event.editor);
    this.viewContainerRef.clear();
    const component = this.viewContainerRef.createComponent(resolvedComponent);
    component.instance.dynamicData = this.data.input;
    component.instance.data = this.data;

    component.instance.indirectlyMenuClickedEvent && this.taskDialogMenuItems.length > 0
      ? component.instance.indirectlyMenuClickedEvent
        .subscribe(editorId => this.indirectMenuItemClickedEvent.next(this.taskDialogMenuItems.find((taskDialogMenuItem => editorId === taskDialogMenuItem.id)))) : null;
    this.componentView = component.instance;
  }

  onOkClicked(): boolean {

    if (DateUtility.isValidDate(this.data.input?.card?.taskStartDate) && DateUtility.isValidDate(this.data.input?.card?.dueDate) &&
      this.data.input.card.taskStartDate.getTime() > this.data.input.card.dueDate.getTime()
    ) {
      this.snackBarService.showError('Please make sure the due date is not set before the start date.');
      return false;
    }

    if (this.data.input.detailFormValueChanged && this.data.input.detailChangedSubject) {
      this.data.input.detailFormValueChanged = false;
      this.data.input.detailChangedSubject.next(this.data.input);
    }

    if (this.componentView && this.componentView.onOkClicked) {
      return this.componentView.onOkClicked();
    }

    return true;
  }

  onCancelClicked(): boolean {
    if (this.componentView && this.componentView.onCancelClicked) {
      return this.componentView.onCancelClicked();
    }
  }

  onClosedClicked(): boolean {
    if (this.componentView && this.componentView.onClosedClicked) {
      return this.componentView.onClosedClicked();
    }
  }

  onOptionalButtonClicked(): boolean {
    if (this.componentView && this.componentView.onOptionalButtonClicked) {
      return this.componentView.onOptionalButtonClicked();
    }
  }

}
